export const LISTING_LOCATION_TYPE = {
  // TRANSLATORS: listing location type
  ONSITE: getText('On-site'),
  // TRANSLATORS: listing location type
  REMOTE: getText('Remote'),
  // TRANSLATORS: listing location type
  REMOTE_TEMPORARY_COVID: getText('Temporarily Remote'),
};
